export const ru = {
    'adjustments-rate':
        'Ставки показаны без учёта применяемых к ним корректировок',
    'button-cancel': 'Отмена',
    'button-submit': 'Применить'
};
